// extracted by mini-css-extract-plugin
export default {"inner-wrapper":"Chat_inner-wrapper__BGFo7"};